import { useLoadsStore } from '@/stores/Loads'
import { useToastStore } from '@/stores/Toast'
import ContextMenuItem from '../ContextMenuItem'
import { useLoadSegmentsStore } from '@/stores/LoadSegments'

/**
 * PrintLoad context menu item.
 *
 * @author Alejandro Sanchez <asanchez@boltsystem.com>
 */
export default class PrintLoad extends ContextMenuItem {
    /**
     * Get the action callback function.
     *
     * @return {Function}
     */
    action() {
        return async () => {
            const segmentsStore = useLoadSegmentsStore()

            await segmentsStore.get(this.params.node.data.id)

            const segmentId = this.params.node.data.current_load_segment_id
            const toastStore = useToastStore()

            if (segmentId) {
                try {
                    toastStore.setNotification({
                        isLoading: true,
                        message: `Downloading Load Sheet`,
                        type: 'info',
                    })

                    const loadStore = useLoadsStore()

                    const url = await loadStore.printLoad(segmentId)

                    toastStore.setNotification({
                        message: `Load sheet printed successfully`,
                        type: 'success',
                    })

                    window.open(url, '_blank', 'noreferrer')
                } catch (error) {
                    toastStore.setNotification({
                        message: error.message(),
                        type: 'error',
                    })
                }
            }
        }
    }

    /**
     * Determine if the menu item should be enabled/disabled.
     *
     * @return {Boolean}
     */
    disabled() {
        const selectedRows = this.params?.api?.getSelectedRows() || []

        return selectedRows.length > 1
    }

    /**
     * The name of the menu item to display.
     *
     * @return {String}
     */
    name() {
        return 'Print Load'
    }

    /**
     * The tooltip to display on hover.
     *
     * @return {String?}
     */
    tooltip() {
        return 'Click to print load sheet'
    }
}
